import {useBreakpointDown} from '@travel-frontend/core';
import {Skeleton} from '@travel-frontend/ui-components';

import {ResultListHeader} from '@/components/ResultListHeader/ResultListHeader';

export const ResultListHeaderPlaceholder = () => {
  const smDown = useBreakpointDown('sm');

  return (
    <ResultListHeader
      title={<Skeleton variant="text" width="160px" height="1.5em" />}
      filterControl={
        smDown ? <Skeleton variant="rect" height="2.5rem" /> : null
      }
      sortingControl={
        smDown ? <Skeleton variant="rect" height="2.5rem" /> : null
      }
    />
  );
};
